const loanDetails = {
  personal: {
    title: "Personal Loan",

    overview:
      "Personal Loan is an unsecured loan designed to meet various personal financial requirements such as medical expenses, education, travel, weddings, home improvements and other immediate needs.",

    features: [
      "No collateral required for eligible applicants",
      "Quick and simple documentation",
      "Flexible loan tenure",
      "Competitive interest rates",
      "Quick processing and approval",
    ],

    interestRate: "As per applicant eligibility and applicable terms",

    loanAmount: "As per eligibility",

    tenure: "Flexible repayment tenure",

    eligibility: [
      "Applicant must meet the minimum age requirement",
      "Regular and stable source of income",
      "Valid identity and address proof",
      "Good credit history",
      "Applicant must satisfy the lender's income and repayment criteria",
    ],

    documents: [
      "Aadhaar Card",
      "PAN Card",
      "Address Proof",
      "Income Proof / Salary Slips",
      "Bank Statements",
      "Passport-size photographs",
    ],

    howToApply: [
      "Contact our loan representative",
      "Fill out the loan application form",
      "Submit the required documents",
      "Complete the verification process",
      "Loan application is reviewed",
      "Get loan approval and disbursement as per applicable terms",
    ],
  },

  business: {
    title: "Business Loan",

    overview:
      "A business loan provides financial support to entrepreneurs and self-employed individuals for business expansion, working capital, inventory, machinery purchases, and other business requirements.",

    interestRate: "19.9% per annum",

    loanAmount: "Based on business profile and eligibility",

    tenure: "Flexible repayment options",

    features: [
      "Interest Rate: 19.9% per annum",
      "Eligibility: Self-Employed Individuals",
      "Business Experience: Minimum 3 Years",
      "Minimum Monthly Income: Above ₹30,000",
      "Flexible repayment options",
      "Fast loan approval & disbursal",
      "Minimal documentation",
    ],

    eligibility: [
      "Self-employed individuals",
      "Minimum 3 years of business experience",
      "Minimum monthly income above ₹30,000",
      "Stable business operations",
      "Good repayment capacity",
    ],

    documents: [
      "Identity Proof",
      "Address Proof",
      "Business Registration Documents",
      "Income / ITR Documents",
      "Bank Statements",
      "Business Proof",
    ],

    howToApply: [
      "Submit the business loan application",
      "Provide the required business and personal documents",
      "Complete the verification process",
      "Get loan approval",
      "Loan amount is disbursed after approval",
    ]
  },


  education: {
    title: "Education Loan",

    overview:
      "Education Loan helps students and their families meet eligible educational expenses such as tuition fees, examination fees and other approved education-related costs.",

    features: [
      "Helps finance eligible education expenses",
      "Flexible repayment options",
      "Support for higher education requirements",
      "Structured repayment options",
      "Simple application process",
    ],

    interestRate: "As per applicable terms and applicant eligibility",

    loanAmount: "As per course and applicant eligibility",

    tenure: "As per applicable repayment schedule",

    eligibility: [
      "Student must meet the applicable admission requirements",
      "Admission to an eligible educational institution or course",
      "Applicant/co-applicant must meet income requirements",
      "Required documents must be submitted",
      "Applicant must satisfy applicable credit criteria",
    ],

    documents: [
      "Student Identity Proof",
      "Aadhaar Card",
      "PAN Card",
      "Address Proof",
      "Admission Letter",
      "Course Fee Structure",
      "Academic Documents",
      "Co-applicant Income Proof",
      "Bank Statements",
    ],

    howToApply: [
      "Contact our loan representative",
      "Provide course and admission details",
      "Submit the application form",
      "Submit student and co-applicant documents",
      "Complete verification",
      "Receive loan approval and disbursement as per applicable terms",
    ]
  },

  gold: {
    title: "Gold Loan",

    overview:
      "A gold loan provides quick access to funds by pledging eligible gold ornaments as security, with minimal documentation and a fast approval process.",

    interestRate: "12.9% per annum",

    loanAmount: "Based on the value of pledged gold",

    tenure: "Up to 1 Year",

    features: [
      "Instant loan against gold",
      "Low interest rates",
      "Safe & secure storage",
      "Interest Rate: 12.9% per annum",
      "Loan Tenure: Up to 1 Year",
      "Minimal documentation",
      "Quick approval & instant disbursal",
    ],

    eligibility: [
      "Applicant must be the owner of the pledged gold",
      "Valid identity and address proof",
      "Gold ornaments must meet the applicable requirements",
      "Applicant must meet the repayment criteria",
    ],

    documents: [
      "Identity Proof",
      "Address Proof",
      "Passport Size Photograph",
      "Gold ownership-related documents, if applicable",
    ],

    howToApply: [
      "Bring the eligible gold ornaments",
      "Submit the required KYC documents",
      "Gold will be evaluated",
      "Loan amount will be determined based on the gold value",
      "Complete the agreement and verification",
      "Loan amount will be disbursed",
    ]
  },

  health: {
    title: "Health Loan",

    overview:
      "Health Loan is designed to provide financial assistance for eligible medical and healthcare-related expenses.",

    features: [
      "Financial assistance for eligible healthcare expenses",
      "Flexible repayment options",
      "Simple documentation",
      "Quick processing for eligible applicants",
      "Support for planned medical expenses",
    ],

    interestRate: "As per applicant eligibility and applicable terms",

    loanAmount: "As per medical requirement and eligibility",

    tenure: "Flexible repayment tenure",

    eligibility: [
      "Applicant must meet the applicable age criteria",
      "Regular and stable source of income",
      "Valid identity and address proof",
      "Medical or treatment-related documents where applicable",
      "Applicant must satisfy applicable credit and repayment criteria",
    ],

    documents: [
      "Aadhaar Card",
      "PAN Card",
      "Address Proof",
      "Income Proof",
      "Bank Statements",
      "Medical Estimate / Hospital Documents",
      "Passport-size photographs",
    ],

    howToApply: [
      "Contact our loan representative",
      "Discuss your healthcare financing requirement",
      "Submit the loan application",
      "Submit the required personal and medical documents",
      "Complete verification",
      "Receive loan decision and disbursement as per applicable terms",
    ]
    
  },

 

  /* =====================================================
     COMMERCIAL LOAN
  ===================================================== */

  commercial: {
    title: "Commercial Loan",

    overview:
      "A Commercial Loan provides financial support to businesses for expansion, working capital, purchasing equipment, managing business expenses, and other commercial requirements.",

    interestRate: "Competitive interest rates",

    loanAmount:
      "Based on business requirement and eligibility",

    tenure:
      "Flexible repayment tenure",

    features: [
      "Suitable for small and medium businesses",
      "Funding for business expansion",
      "Can be used for working capital requirements",
      "Finance for machinery and equipment",
      "Flexible repayment options",
      "Simple documentation process",
      "Loan amount based on business eligibility",
      "Competitive interest rates"
    ],

    eligibility: [
      "Applicant should be engaged in a valid business activity",
      "Business should have a stable financial history",
      "Applicant should meet the required age criteria",
      "Business income should meet the required eligibility",
      "Valid identity and address proof is required",
      "Required financial and business documents must be submitted"
    ],

    documents: [
      "PAN Card",
      "Aadhaar Card",
      "Address Proof",
      "Business Registration Documents",
      "Bank Statements",
      "Income Tax Returns",
      "Business Financial Statements",
      "Photographs"
    ],

    howToApply: [
      "Contact our loan representative",
      "Submit your basic business and personal details",
      "Provide the required documents",
      "Complete the eligibility and verification process",
      "Loan application will be reviewed",
      "Get approval and complete the required formalities"
    ],

    faqs: [
      {
        question: "What is a Commercial Loan?",
        answer:
          "A Commercial Loan is financing provided to businesses for working capital, expansion, equipment purchases, and other business-related requirements."
      },
      {
        question: "Who can apply for a Commercial Loan?",
        answer:
          "Business owners, self-employed individuals, and eligible enterprises can apply subject to the applicable eligibility criteria."
      },
      {
        question: "What can a Commercial Loan be used for?",
        answer:
          "The loan can be used for business expansion, working capital, equipment purchase, inventory, and other eligible commercial requirements."
      },
      {
        question: "What documents are required?",
        answer:
          "Commonly required documents include identity proof, address proof, business documents, bank statements, income tax returns, and financial statements."
      }
    ]
  },


  /* =====================================================
     LOAN AGAINST SECURITY
  ===================================================== */

  security: {
    title: "Loan Against Security",

    overview:
      "Loan Against Security allows eligible customers to raise funds by providing eligible financial securities as collateral. It can help meet personal, business, or other financial requirements.",

    interestRate: "Competitive interest rates",

    loanAmount:
      "Based on the value of eligible securities",

    tenure:
      "Flexible repayment tenure",

    features: [
      "Funding against eligible securities",
      "Competitive interest rates",
      "Flexible repayment options",
      "Useful for personal and business requirements",
      "Loan amount based on security value",
      "Simple application process",
      "Quick documentation and verification",
      "Retain ownership of eligible securities subject to terms"
    ],

    eligibility: [
      "Applicant should meet the required age criteria",
      "Applicant should have eligible securities",
      "Securities must meet applicable requirements",
      "Applicant should have valid identity and address proof",
      "Financial eligibility will be evaluated",
      "All required documents must be submitted"
    ],

    documents: [
      "PAN Card",
      "Aadhaar Card",
      "Address Proof",
      "Photographs",
      "Financial Statements where applicable",
      "Details of Securities",
      "Bank Statements",
      "Other supporting documents"
    ],

    howToApply: [
      "Contact our representative",
      "Submit your personal details",
      "Provide details of the securities",
      "Submit the required documents",
      "Complete verification and valuation",
      "Complete loan documentation and formalities"
    ],

    faqs: [
      {
        question: "What is a Loan Against Security?",
        answer:
          "It is a loan where eligible financial securities are provided as collateral to obtain funding."
      },
      {
        question: "What securities can be used?",
        answer:
          "Eligible securities depend on the applicable lending policy and may include approved financial investments."
      },
      {
        question: "How is the loan amount decided?",
        answer:
          "The eligible loan amount is generally determined based on the value and type of securities and applicable lending terms."
      }
    ]
  },


  /* =====================================================
     VEHICLE LOAN
  ===================================================== */

  vehicle: {
    title: "Vehicle Loan",

    overview:
      "Vehicle Loan provides financing support for purchasing eligible new or used vehicles for personal or business use.",

    interestRate: "Competitive interest rates",

    loanAmount:
      "Based on vehicle value and eligibility",

    tenure:
      "Flexible repayment options",

    features: [
      "Finance for eligible new vehicles",
      "Finance options for selected used vehicles",
      "Flexible repayment tenure",
      "Competitive interest rates",
      "Simple documentation process",
      "Quick application and verification",
      "Suitable for personal or business use",
      "Convenient repayment options"
    ],

    eligibility: [
      "Applicant should meet the required age criteria",
      "Applicant should have a stable source of income",
      "Vehicle should meet applicable eligibility requirements",
      "Applicant should have valid identity and address proof",
      "Credit and repayment capacity may be evaluated",
      "Required documents must be submitted"
    ],

    documents: [
      "PAN Card",
      "Aadhaar Card",
      "Address Proof",
      "Income Proof",
      "Bank Statements",
      "Vehicle Quotation",
      "Photographs",
      "Other supporting documents"
    ],

    howToApply: [
      "Select your desired vehicle",
      "Contact our representative",
      "Submit your personal and income details",
      "Submit the required documents",
      "Complete verification",
      "Complete loan documentation",
      "Get loan approval and proceed with the vehicle purchase"
    ],

    faqs: [
      {
        question: "What is a Vehicle Loan?",
        answer:
          "A Vehicle Loan provides financial assistance for purchasing an eligible vehicle."
      },
      {
        question: "Can I apply for a used vehicle?",
        answer:
          "Selected used vehicles may be eligible depending on the vehicle condition, age, valuation, and applicable lending policy."
      },
      {
        question: "What documents are required?",
        answer:
          "Common documents include identity proof, address proof, income proof, bank statements, and the vehicle quotation."
      }
    ]
  },


  /* =====================================================
     CREDIT CARD
  ===================================================== */

  credit: {
    title: "Credit Card",

    overview:
      "A Credit Card provides convenient access to a pre-approved credit limit for eligible purchases, payments, and other permitted transactions.",

    interestRate:
      "Applicable charges as per card terms",

    loanAmount:
      "Credit limit based on eligibility",

    tenure:
      "Revolving credit facility",

    features: [
      "Convenient cashless payments",
      "Flexible payment options",
      "Credit limit based on eligibility",
      "Useful for everyday purchases",
      "Online and offline transaction support",
      "Secure payment facility",
      "Easy transaction tracking",
      "Applicable rewards and benefits as per card terms"
    ],

    eligibility: [
      "Applicant should meet the required age criteria",
      "Applicant should have a stable source of income",
      "Valid identity and address proof is required",
      "Credit profile may be evaluated",
      "Applicant should meet the applicable income criteria",
      "Required documents must be submitted"
    ],

    documents: [
      "PAN Card",
      "Aadhaar Card",
      "Address Proof",
      "Income Proof",
      "Bank Statements",
      "Salary Slips where applicable",
      "Photograph",
      "Other supporting documents"
    ],

    howToApply: [
      "Submit your basic personal details",
      "Provide required income and identity documents",
      "Complete the verification process",
      "Application will be evaluated",
      "Complete applicable formalities",
      "Receive your card subject to approval"
    ],

    faqs: [
      {
        question: "What is a Credit Card?",
        answer:
          "A Credit Card allows eligible customers to make purchases and payments using an approved credit limit."
      },
      {
        question: "How is the credit limit decided?",
        answer:
          "The credit limit is determined based on factors such as income, credit profile, repayment capacity, and applicable policy."
      },
      {
        question: "Can I use a Credit Card online?",
        answer:
          "Yes, subject to the card's terms and applicable transaction limits, a credit card can generally be used for eligible online transactions."
      }
    ]
  },


  /* =====================================================
     INSURANCE
  ===================================================== */

  insurance: {
    title: "Insurance",

    overview:
      "Insurance solutions help provide financial protection against eligible risks and unexpected expenses. Choose coverage based on your individual, family, vehicle, or business requirements.",

    interestRate:
      "Premium based on selected coverage",

    loanAmount:
      "Coverage based on policy terms",

    tenure:
      "As per selected insurance policy",

    features: [
      "Financial protection against eligible risks",
      "Multiple insurance options",
      "Coverage based on individual requirements",
      "Flexible policy options",
      "Simple documentation process",
      "Policy support and assistance",
      "Suitable plans for different needs",
      "Renewal support as applicable"
    ],

    eligibility: [
      "Eligibility depends on the selected insurance product",
      "Applicant should provide accurate personal information",
      "Age and other criteria may apply",
      "Medical information may be required for selected policies",
      "Vehicle details may be required for motor insurance",
      "Required documents must be submitted"
    ],

    documents: [
      "PAN Card",
      "Aadhaar Card",
      "Address Proof",
      "Photograph",
      "Income Documents where applicable",
      "Vehicle Documents for motor insurance",
      "Medical Documents where applicable",
      "Other policy-specific documents"
    ],

    howToApply: [
      "Choose the insurance product suitable for your requirement",
      "Contact our representative",
      "Provide your personal and policy details",
      "Submit the required documents",
      "Complete verification where applicable",
      "Review policy terms and premium",
      "Complete the applicable formalities"
    ],

    faqs: [
      {
        question: "Why do I need Insurance?",
        answer:
          "Insurance can provide financial protection against specified risks and unexpected expenses, subject to the policy terms and conditions."
      },
      {
        question: "What types of Insurance are available?",
        answer:
          "Insurance options may include health, life, motor, property, and other eligible insurance products depending on availability."
      },
      {
        question: "How is the premium decided?",
        answer:
          "Premium depends on factors such as the type of policy, coverage selected, applicant details, risk factors, and applicable policy terms."
      }
    ]
  },


  /* =====================================================
     HOME LOAN
  ===================================================== */

  home: {
    title: "Home Loan",

    overview:
      "Turn your dream home into reality with affordable home loans, competitive interest rates, high loan eligibility, and hassle-free processing.",

    interestRate: "Starting from 8.5% per annum",

    loanAmount: "High loan amount eligibility",

    tenure: "Up to 300 months",

    features: [
      "Interest Rate: Starting from 8.5% per annum",
      "Loan Tenure: Up to 300 months",
      "Eligibility: Minimum 2 Years of Work/Business Experience",
      "Available for Salaried Employees",
      "Available for Self-Employed Professionals & Business Owners",
      "High loan amount eligibility",
      "Quick approval with minimal documentation",
    ],

    eligibility: [
      "Minimum 2 Years of Work/Business Experience",
      "Available for Salaried Employees",
      "Available for Self-Employed Professionals",
      "Available for Business Owners",
      "Applicant must have a stable source of income",
      "Applicant must have sufficient repayment capacity",
    ],

    documents: [
      "Identity Proof",
      "Address Proof",
      "Income Proof",
      "Salary Slips for Salaried Applicants",
      "Bank Statements",
      "ITR Documents for Self-Employed Applicants",
      "Property-related Documents",
    ],

    howToApply: [
      "Submit the Home Loan application",
      "Provide personal and income-related documents",
      "Submit the required property documents",
      "Complete verification and property evaluation",
      "Get loan approval",
      "Complete the required documentation",
      "Loan amount is disbursed",
    ],

    faqs: [
      {
        question: "What is the interest rate for a Home Loan?",
        answer:
          "The Home Loan interest rate starts from 8.5% per annum.",
      },
      {
        question: "What is the maximum Home Loan tenure?",
        answer:
          "The Home Loan tenure can be up to 300 months.",
      },
      {
        question: "Who can apply for a Home Loan?",
        answer:
          "Salaried employees, self-employed professionals, and business owners who meet the eligibility criteria can apply.",
      },
      {
        question: "What is the minimum work or business experience required?",
        answer:
          "A minimum of 2 years of work or business experience is required.",
      },
    ],
  },

};


export default loanDetails;